import * as React from "react";
import { Accordion } from "../../../../../../../react-core/Html/Accordion";
import { Typography } from "../../../../../../Shared/Typography/Typography";
import { IReviewProps, moneyParse } from "../ReviewParser";

export const OneOffWithdrawalReview = (props: IReviewProps) => {
    const { data, onEditAction } = props;

    const config = () => {
        if (!data) {return [];}
        const config = [
            {
                title: "One off withdrawal",
                data: moneyParse(data?.OneOffWithdrawal?.Amount.Amount),
            },
        ];
        return config;
    };

    return (
        <Accordion label="One off withdrawal" isOpen={false} onEdit={() => onEditAction()}>
            <div className="pl-34">
                <Typography type="common" config={config()}></Typography>
            </div>
        </Accordion>
    );
};
